export default __webpack_public_path__ + "static/media/background.21fc115f.png";